module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/473.0d8ecf5c.png";